import EGNYTE_PLATFORM from '@integrations/pint-appstore-commons/src/enums/EGNYTE_PLATFORM.json';
import settingsPopupObserver from '../../components/settingsPopupObserver';

const GDRIVE_APP_ID = 'EGNYTE_GDRIVE_INTEG';
const newWindowWidth = 830;
const newWindowHeight = 830;
const newWindowMinOffset = 100;

function getCenteredPopupCoordinates() {
    let leftOffset = (window.innerWidth - newWindowWidth) / 2;
    if (leftOffset < newWindowMinOffset) {
        leftOffset = newWindowMinOffset;
    }

    return `width=${newWindowWidth},height=${newWindowHeight},top=${newWindowMinOffset},left=${leftOffset}`;
}

export default function getOpenSettings(
    {
        settingsURL,
        token,
        saveUrl,
        domain,
        appId,
        confirmUrl,
        setupUpdateUrl,
        dispatchFetchStatusForm,
        isConfigured,
        domainSettingsRequired,
        dispatchCloseSettingsInfoPopup,
    },
    { enableAppConfigurationUpdates = true }
) {
    /* eslint-disable-next-line-complexity */
    return function openSettings() {
        let url = `${settingsURL}?token=${encodeURIComponent(token)}&save_url=${encodeURIComponent(
            saveUrl
        )}&domain=${encodeURIComponent(domain)}`;

        if (enableAppConfigurationUpdates) {
            url +=
                // TODO this query param should be removed after switching Collab to using configuration_update_url
                `&confirm_url=${encodeURIComponent(confirmUrl)}&configuration_update_url=${
                    encodeURIComponent(setupUpdateUrl)
                    // TODO this query param should be removed after changes in Sumo Logic
                }&configuration_exists=${!!isConfigured?.[EGNYTE_PLATFORM.SECURE_AND_GOVERN]}`;

            const configuredPlatforms = [];
            isConfigured?.[EGNYTE_PLATFORM.COLLABORATE] && configuredPlatforms.push(EGNYTE_PLATFORM.COLLABORATE);
            isConfigured?.[EGNYTE_PLATFORM.SECURE_AND_GOVERN] &&
                configuredPlatforms.push(EGNYTE_PLATFORM.SECURE_AND_GOVERN);
            if (configuredPlatforms.length > 0) {
                url = `${url}&configured_platforms=${configuredPlatforms.join(',')}`;
            }
        }

        if (appId === GDRIVE_APP_ID) {
            // We want bigger window here since opened page for Gdrive will not fit the pop-up window.
            // The settings for this integration is actually opened though CFS settings page. So first we are loading whole settings page for a domain.
            window.open(url);
        } else {
            const settingsWindow = window.open(url, appId, getCenteredPopupCoordinates());

            if (domainSettingsRequired) {
                const modal = document.querySelector('.sg-modal-content');

                settingsPopupObserver.observe({
                    appId,
                    element: modal,
                    popupWindow: settingsWindow,
                    reactionCallback: dispatchFetchStatusForm.bind(null, appId),
                });
            }
        }
        if (dispatchCloseSettingsInfoPopup) {
            dispatchCloseSettingsInfoPopup();
        }
    };
}
